let utils = {
    setContent(content) {
        //音频数据处理
        if (Array.isArray(content)) return content
        let reg = /\[audio=.*?\.mp3\]/g
        let txtArr = content.split(reg)
        let mp3Arr = content.match(reg)
        let arr = []
        txtArr.forEach((el, index) => {
            el.length && arr.push({ type: 'stem', content: el })
            if (index != txtArr.length - 1) {
                arr.push({
                    type: 'mp3',
                    content: mp3Arr[index].split('=')[1].replace(']', ''),
                    name: mp3Arr[index]
                })
            }
        })
        return arr
    },
    setHighLight(content, keyword) {
        //高亮数据处理
        if (keyword.length == 0) return content
        keyword.forEach(el => {
            let arr = content.split('$$')
            if (arr.length % 2 == 1) {
                arr.forEach((a, i) => {
                    if (i % 2 == 0) {
                        let alist = a.split('<')
                        alist.forEach((b, n) => {
                            if (!b.includes('>')) {
                                alist[n] = utils.regHighLight(el, b)
                            } else {
                                let bs = b.split('>')
                                bs[1] = utils.regHighLight(el, bs[1])
                                alist[n] = bs.join('>')
                            }
                        })
                        arr[i] = alist.join('<')
                    }
                })
                content = arr.join('$$')
            }
        })
        return content
    },
    regHighLight(el, txt) {
        //高亮数据正则
        let content = ''
        try {
            if (/^[a-zA-Z\s]+$/i.test(el)) {
                content = txt.replace(
                    new RegExp('(\\b|\\bwo)(' + el + ')\\b', 'gi'),
                    data => {
                        //验证是一个完整单词时高亮
                        return (
                            "<span style='color:#FF3030;font-weight:bold'>" +
                            data +
                            '</span>'
                        )
                    }
                )
            } else {
                el = el.replace(/\./g, '')
                content = txt.replace(
                    new RegExp(el, 'gi'),
                    "<span style='color:#FF3030;font-weight:bold'>" +
                        el +
                        '</span>'
                )
            }
            return content
        } catch (error) {
            return txt
        }
    },
    avoidXSS(val) {
        if (typeof val == 'undefined') return ''
        val = String(val)
        let reg = /(onabort|onactivate|onafterprint|onafterupdate|onbeforeactivate|onbeforecopy|onbeforecut|onbeforedeactivate|onbeforeeditfocus|onbeforepaste|onbeforeprint|onbeforeunload|onbeforeupdate|onblur|onbounce|oncellchange|onchange|onclick|oncontextmenu|oncontrolselect|oncopy|oncut|ondataavailable|ondatasetchanged|ondatasetcomplete|ondblclick|ondeactivate|ondrag|ondragend|ondragenter|ondragleave|ondragover|ondragstart|ondrop|onerror|onerrorupdate|onfilterchange|onfinish|onfocus|onfocusin|onfocusout|onhelp|onkeydown|onkeypress|onkeyup|onlayoutcomplete|onload|onlosecapture|onmousedown|onmouseenter|onmouseleave|onmousemove|onmouseout|onmouseover|onmouseup|onmousewheel|onmove|onmoveend|onmovestart|onpaste|onpropertychange|onreadystatechange|onreset|onresize|onresizeend|onresizestart|onrowenter|onrowexit|onrowsdelete|onrowsinserted|onscroll|onselect|onselectionchange|onselectstart|onstart|onstop|onsubmit|onunload)/gi
        val = val.replace(reg, `'$1'`)
        val = val.replace(/\<(.*?script.*?|.*?\/script.*?)\>/gm, `&lt;$1&gt;`)
        return val
    }
}
export default utils



// WEBPACK FOOTER //
// ./packages/question-single/src/utils.js